import React from 'react';
import {Route, Routes} from 'react-router-dom';

import {
    ClockCircleOutlined,
    ApartmentOutlined,
    AppstoreAddOutlined,
    AppstoreOutlined,
    FileOutlined,
    FileProtectOutlined,
    SettingOutlined,
    TagsOutlined,
    CloudSyncOutlined,
} from '@/icons';
import AuthRoute from '@/page/component/AuthRoute';

const PARENT_PREFIX = '/admin';

// 父级 <Route path="/admin/*"> 已经消耗了 /admin，
// 子级 <Routes> 必须用相对路径。菜单配置里保持绝对路径便于 navigate/matchPath。
const toRelative = (absPath) => {
    if (absPath === PARENT_PREFIX) {
        return '';
    }
    if (absPath === '*') {
        return '*';
    }
    if (absPath.startsWith(PARENT_PREFIX + '/')) {
        return absPath.slice(PARENT_PREFIX.length + 1);
    }
    return absPath;
};

export const AdminRouteConfig = [
    {
        path: '/admin',
        exact: true,
        component: require('./AdminRedirect').default,
    },
    {
        label: '应用管理',
        path: '/admin/apps',
        icon: <AppstoreAddOutlined />,
        authorities: ['global:app:r', 'global:app:w'],
        component: require('./AppsPage').default,
    },
    {
        path: '/admin/appcustom',
        authorities: ['global:app:r', 'global:app:w'],
        component: require('./AppCustomPage').default,
    },
    {
        label: '组织结构',
        path: '/admin/departs',
        icon: <ApartmentOutlined />,
        authorities: ['global:depart:r', 'global:depart:w'],
        component: require('./DepartsPage').default,
    },
    {
        label: '标签管理',
        path: '/admin/tags',
        icon: <TagsOutlined />,
        authorities: ['global:tag:r', 'global:tag:w'],
        component: require('./TagsPage').default,
    },
    {
        label: '角色管理',
        path: '/admin/roles',
        icon: <FileProtectOutlined />,
        authorities: ['global:role:r', 'global:role:w'],
        component: require('./RolesPage').default,
    },
    {
        label: '外部应用',
        path: '/admin/clientapps',
        icon: <AppstoreOutlined />,
        authorities: ['global:clientApp:r', 'global:clientApp:w'],
        component: require('./ClientAppsPage').default,
    },
    {
        label: '企业设置',
        path: '/admin/settings',
        icon: <SettingOutlined />,
        authorities: ['global:corp:r', 'global:corp:w'],
        component: require('./SettingsPage').default,
    },
    {
        label: '员工同步设置',
        path: '/admin/bi-sync',
        icon: <CloudSyncOutlined />,
        authorities: ['global:depart:r', 'global:depart:w'],
        component: require('./BiUserSync').default,
    },
    {
        label: '敏感词管理',
        path: '/admin/intercept-rule',
        icon: <FileProtectOutlined />,
        authorities: ['global:sys_intercept:r', 'global:sys_intercept:w'],
        component: require('./InterceptRulePage').default,
    },
    {
        label: '定时任务',
        path: '/admin/jobs',
        icon: <ClockCircleOutlined />,
        authorities: ['global:sys_job:r', 'global:sys_job:w'],
        component: require('./JobsPage').default,
    },
    {
        label: '系统日志',path: '/admin/logs',
        icon: <FileOutlined />,
        authorities: ['global:log:r'],
        component: require('./LogsPage').default,
    },
    /*{
        label: '异步任务日志',
        path: '/admin/synclogs',
        icon: <RollbackOutlined />,
        authorities: ['global:asyncLog:r'],
        component: require('./SyncLogsPage').default,
    },*/
    {
        path: '/admin/*',
        component: require('../NotFoundPage').default,
    },
];

export const MenuConfig = AdminRouteConfig.filter(item => !!item.label);

export default function AppRoutes() {
    return (
        <Routes>
            {AdminRouteConfig.map(({path, authorities, component: Component}) => {
                return (
                    <Route
                        key={`route${path}`}
                        path={toRelative(path)}
                        element={
                            <AuthRoute onAuthorities={authorities}>
                                <Component />
                            </AuthRoute>
                        }
                    />
                );
            })}
        </Routes>
    );
}
